export default "__VITE_ASSET__4a124536__"